import { getUniversityChecksOverview, updateUniversity } from "@helpers/api";
import { useEffect, useState, lazy, Suspense } from "react";
import useAPI from "@stores/api";
import Grid from "@mui/material/Unstable_Grid2";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ConditionalRender from "@components/ConditionalRender";
import WidgetGroup from "@components/statistics/WidgetGroup";
import UniversityChecksDataGrid from "@components/statistics/checks/UniversityChecksDataGrid";
const AdminEmbedded = lazy(() =>
  import("@components/statistics/AdminEmbedded")
);
const EmbeddingsOverview = lazy(() =>
  import("@components/statistics/embedding/EmbeddingsOverview")
);
const AvailabilityOverview = lazy(() =>
  import("@components/statistics/availability/AvailabilityOverview")
);

/**
 * @typedef UniversityCheck
 * @property {string} university
 * @property {number} document_count
 * @property {string} latest_document_date
 */

/**
 * @typedef UniversityChecksOverview
 * @property {UniversityCheck[]} universities
 */

const Checks = () => {
  let token = useAPI((state) => state.token);

  /** @type {[UniversityChecksOverview,React.Dispatch<React.SetStateAction<{}>>]} */
  let [checks, setChecks] = useState(undefined);
  let [tab, setTab] = useState(0);

  function fetchData() {
    getUniversityChecksOverview(token)
      .then((data) => {
        setChecks(data);
      })
      .catch((error) => {
        console.error("Error fetching university checks:", error);
        setChecks({ universities: [] });
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  function handleUpdate(university) {
    updateUniversity(university, token)
      .then(() => fetchData())
      .catch((error) => console.error("Error updating university:", error));
  }

  return (
    <div className="pagina statistics-page compact">
      <Grid container>
        <ConditionalRender condition={checks != undefined}>
          <WidgetGroup className="compact-header">
            <div className="checks-submenu">
              <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                aria-label="checks submenu"
                textColor="primary"
                indicatorColor="primary"
                variant="scrollable"
              >
                <Tab label="Docs" />
                <Tab label="Embeddings" />
                <Tab label="Stats" />
                <Tab label="Availability" />
              </Tabs>
            </div>
          </WidgetGroup>
          {tab === 0 && (
            <WidgetGroup className="compact-body checks-content">
              <div className="university-checks-data-grid tall">
                <UniversityChecksDataGrid
                  data={checks}
                  onUpdate={handleUpdate}
                />
              </div>
            </WidgetGroup>
          )}
          {tab === 1 && (
            <WidgetGroup className="compact-body checks-content">
              <div style={{ width: "100%" }}>
                <Suspense
                  fallback={<div style={{ padding: "1rem" }}>Cargando…</div>}
                >
                  <EmbeddingsOverview />
                </Suspense>
              </div>
            </WidgetGroup>
          )}
          {tab === 2 && (
            <WidgetGroup className="compact-body checks-content">
              <div style={{ width: "100%" }}>
                <Suspense
                  fallback={<div style={{ padding: "1rem" }}>Cargando…</div>}
                >
                  <AdminEmbedded />
                </Suspense>
              </div>
            </WidgetGroup>
          )}
          {tab === 3 && (
            <WidgetGroup className="compact-body checks-content">
              <div style={{ width: "100%" }}>
                <Suspense
                  fallback={<div style={{ padding: "1rem" }}>Cargando…</div>}
                >
                  <AvailabilityOverview />
                </Suspense>
              </div>
            </WidgetGroup>
          )}
        </ConditionalRender>
      </Grid>
    </div>
  );
};

export default Checks;
